import { render } from "./AllProductTransfer.vue?vue&type=template&id=650e1d85&scoped=true"
import script from "./AllProductTransfer.vue?vue&type=script&lang=js"
export * from "./AllProductTransfer.vue?vue&type=script&lang=js"

import "./AllProductTransfer.vue?vue&type=style&index=0&id=650e1d85&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650e1d85"]])

export default __exports__